import { Layout as PropsLayout } from '@/models/Props';

import { LFlexSystem } from '@/components/layouts';

import './Scrolling.scss';

const Scrolling = ({ children }: PropsLayout) => {
    return (
        <section aria-label={'Companies logos'} className={'logos'}>
            <LFlexSystem
                className={'logos__container'}
                sortChildren={'columns'}
                positioning={{
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                {children}
            </LFlexSystem>
        </section>
    );
};

export default Scrolling;
